import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SafetyCertificateFilled } from "@ant-design/icons";
import { theme } from "antd";
import { __ } from "../../../../utils/i18n.js";
/**
 * Money-back callout. Structural styling (card shell with left-accent
 * stripe, title / body typography) lives in `style/checkoutV2.scss` under
 * the `.checkout-v2-moneyback*` classes; only token-derived colours stay
 * inline on the React side.
 */ const MoneyBackGuarantee = ()=>{
    const { token } = theme.useToken();
    return /*#__PURE__*/ _jsxs("div", {
        className: "checkout-v2-moneyback",
        children: [
            /*#__PURE__*/ _jsx(SafetyCertificateFilled, {
                style: {
                    color: token.colorSuccess
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "checkout-v2-moneyback__title",
                        style: {
                            color: token.colorTextHeading
                        },
                        children: __("14-Day Money-Back Guarantee")
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "checkout-v2-moneyback__body",
                        style: {
                            color: token.colorText
                        },
                        children: __("Try it risk-free. If it's not the right fit for your website, we'll refund your payment to the original payment method.")
                    })
                ]
            })
        ]
    });
};
export { MoneyBackGuarantee };
